exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".underline-dotted[data-v-3be6b193]{border-bottom:1px dashed #999}.cursor-pointer:hover .underline-dotted[data-v-3be6b193],.underline-dotted[data-v-3be6b193]:hover{border-bottom:1px dashed transparent}.hide-button[data-v-3be6b193]{display:none!important}", ""]);

// exports
